function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.048 5.591a.708.708 0 00-.615-.341H8.527L9.324.765a.649.649 0 00-.419-.713.725.725 0 00-.836.217L2.935 6.832a.621.621 0 00-.06.684c.12.22.362.359.625.359h2.935l-.76 5.382a.651.651 0 00.454.703c.078.027.159.04.24.04.232 0 .457-.11.589-.303l5.065-7.437a.623.623 0 00.025-.669z",
  fill: "#333"
});

function SvgIconPowers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
}

export default SvgIconPowers;